import * as angular from 'angular';
import { StateParams } from '@uirouter/angularjs';

import {
    IAuthorizationService,
    IConfigurationService,
    ICurrentApplicationService,
    IDateRangeService,
    IStoreActionsService,
    IValidationPageConfigurationService
} from '../services';
import * as StateErrors from '../common/StateErrors';
import { getGroup } from './validationStandAlone/getGroup';
import { Workspace } from '@models/Workspace';

export function standAlone(
    $stateParams: angular.ui.IStateParamsService,
    $q: angular.IQService,
    configurationService: IConfigurationService,
    storeActionsService: IStoreActionsService
): angular.IPromise<unknown> {
    const workspace: Workspace = {
        application: $stateParams['appName'],
        environment: $stateParams['appEnv'],
        model: $stateParams['appModel']
    };

    const defered = $q.defer();

    configurationService
        .getConfiguration()
        .then(() => storeActionsService.authentication.login({ userName: $stateParams['user'], password: $stateParams['password'] }))
        .then(() => storeActionsService.authentication.connectByWorkspace($stateParams['user'], workspace))
        .then(() => defered.resolve(true))
        .catch(reason => {
            console.log(`Error: ${reason}`);
            storeActionsService.authentication.logout();
            defered.reject(reason);
        });

    return defered.promise;
}

function isInRoles(roles: string[]): (authorizationService, $q) => boolean | angular.IPromise<never> {
    return (authorizationService, $q) => {
        const isOk = authorizationService.isInRoles(roles);
        return isOk ? false : $q.reject(StateErrors.notAuthorized);
    };
}

function auth(authorizationService: IAuthorizationService, $q: angular.IQService): boolean | angular.IPromise<never> {
    const isOk = authorizationService.isAuthenticated();
    return isOk ? false : $q.reject(StateErrors.notAuthenticated);
}

function connected(authorizationService: IAuthorizationService, $q: angular.IQService): boolean | angular.IPromise<never> {
    const isOk = authorizationService.isConnected();
    return isOk ? false : $q.reject(StateErrors.notConnected);
}

function isCurrentUser(paramName: string): (authorizationService: IAuthorizationService, $q: angular.IQService, $stateParams) => boolean | angular.IPromise<never> {
    return (authorizationService, $q, $stateParams) => {
        const isOk = authorizationService.isCurrentUser(paramName, $stateParams);
        return isOk ? false : $q.reject(StateErrors.notAuthorized);
    };
}

function isSuperAdminOrCurrentUser(paramName: string): (authorizationService: IAuthorizationService, $q: angular.IQService, $stateParams) => boolean | angular.IPromise<never> {
    return (authorizationService, $q, $stateParams) => {
        const isOk = authorizationService.isCurrentUser(paramName, $stateParams) || authorizationService.isSuperAdmin();
        return isOk ? false : $q.reject(StateErrors.notAuthorized);
    };
}

function dates(dateRangeService: IDateRangeService, $stateParams: angular.ui.IStateParamsService) {
    return dateRangeService.initByState($stateParams);
}

function appConfiguration(currentApplicationService: ICurrentApplicationService) {
    return currentApplicationService.getApplicationConfiguration();
}

export function userResolve(paramName: string) {
    return ['authorizationService', '$q', '$stateParams', isCurrentUser(paramName)];
}

export function superAdminOrUserResolve(paramName: string) {
    return ['authorizationService', '$q', '$stateParams', isSuperAdminOrCurrentUser(paramName)];
}

export const authResolve = ['authorizationService', '$q', auth];
export const connectedResolve = ['authorizationService', '$q', connected];
export const rolesResolve = (roles: string[]) => ['authorizationService', '$q', isInRoles(roles)];
export const datesResolve = ['dateRangeService', '$stateParams', dates];
export const appConfigurationResolve = ['currentApplicationService', appConfiguration];
export const licenseResolve = ['$q', 'configurationService', ($q: angular.IQService, configurationService: IConfigurationService) => {
    return configurationService
        .getApiInformation()
        .then(data => {
            return data.isLicenseValid ? false : $q.reject(StateErrors.invalidLicense);
        });
}];
export const groupResolve = ['$stateParams', 'validationPageConfigurationService', ($stateParams: StateParams, vpcs: IValidationPageConfigurationService) => {
    return getGroup($stateParams['groupGuid'], vpcs);
}];